
import { Button } from "@portal/BaseComponents/Button/AntButton";
import { ToolTip } from "@portal/BaseComponents/ToolTip/AntTooltip";
import useOpen from "@portal/hooks/useOpen";
import { Icon } from "@portal/lib/icons/icons";
import { ActivitiesActionButtonProps } from "../type";
import { AddDocumentModal } from "./AddDocumentForm/AddDocumentForm";

interface AddDocumentsProps extends ActivitiesActionButtonProps {}

const t = {
  title: "Add Document(s)",
};

function AddDocument(props: AddDocumentsProps) {
  const {
    title = t.title,
    buttonProps,
    iconOnly,
    showToolTip,
    hideIcon,
    onOpenChange,
  } = props;
  const { open, onClose, toggleOpen } = useOpen({ open: false });

  function handleClose() {
    onOpenChange?.(false);
    onClose();
  }

  function handleOpen() {
    onOpenChange?.(true);
    toggleOpen();
  }
  const DocumentIcon = hideIcon ? null : (
    <Icon icon={['far','file-arrow-up']} color="var(--primary-7)"  />
  );
  const Modal = <AddDocumentModal open={open} onClose={handleClose} />;
  return (
    <>
      <ToolTip open={showToolTip ? undefined : false} title={t.title}>
        <Button icon={DocumentIcon} {...buttonProps} onClick={handleOpen}>
          {iconOnly ? null : title}
        </Button>
      </ToolTip>
      {open&&Modal}
    </>
  );
}

export { AddDocument };
